import { render } from "./ProfitExpectancy.vue?vue&type=template&id=5ced8969"
import script from "./ProfitExpectancy.vue?vue&type=script&lang=js"
export * from "./ProfitExpectancy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__